var localeEs = {
  es: {
    DEFAULT_CTA_LABEL: 'Conversemos',
    DEFAULT_TITLE: 'Accede a Crehana con una llamada',
    DEFAULT_DESCRIPTION: 'Ingresa tus datos y te asesoraremos con nuestras mejores ofertas en Premium.',
    CALL_CENTER_DIALOG_NAME: 'Nombre',
    REQUIRED_FIELD: 'Campo requerido',
    MAX_CHARS: 'Máximo 50 caracteres',
    PHONE_NUMBER: 'Número de celular'
  }
};
export default localeEs;